module.exports = __webpack_public_path__ + "static/media/stopwatch.46942e61.gif";